// @flow
import { useState, useEffect } from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';

import selectStudentsAsReceivers from './selectStudentsAsReceivers';
import requestEmployeeUuid from './requestEmployeeUuid';


/**
 *  Извлечение получателей будущего заказа
 *  ** ...Дети, если они есть (они есть только в кабинете родителя)
 *  ** ...Пользователь кабинета, если он сотрудник или если нет детей
 */

type UserProps = {
  name: string,
  email: string,
  phone: string,
}

export default function (
  userUuid: string, // пользователь магазина
  userProps: UserProps, // данные из формы
  deliveryPointUuid: string, // точка доставки
) {
  const dispatch = useDispatch();
  const { name, email, phone } = userProps;
  const studentsAsReceivers = useSelector(state => selectStudentsAsReceivers(state, { deliveryPointUuid }));

  const [userAsReceiverUuid, setUserAsReceiverUuid] = useState('');
  const [lastRequestId, setLastRequestId] = useState(0);

  const {
    loading: loadingUser,
    employee,
  } = useSelector(state => state.user, shallowEqual);

  const employeeId = employee && employee.id;
  const existStudentsAsReceivers = !!studentsAsReceivers;

  // userAsReceiverUuid init
  useEffect(() => {
    if (loadingUser) return;
    (async () => {
      // КАБИНЕТ РОДИТЕЛЕЙ
      if ((process.env.APP_NAME || process.env.REACT_APP_NAME) === 'cabinet') {
        // 1. если родитель еще и сотрудник, извлекаем его uuid запросом
        // 2. если нет детей, получатель - пользователь, кто бы он ни был
        // Но сначала пробуем получить его как сотрудника
        if (employeeId) {
          if (lastRequestId === employeeId) return;
          const uuid = await requestEmployeeUuid(employeeId, dispatch);
          setLastRequestId(employeeId);
          if (uuid) {
            setUserAsReceiverUuid(uuid);
            return;
          }
        }
        if (!existStudentsAsReceivers) {
          setUserAsReceiverUuid(userUuid);
        }
      }

      // ОСТАЛЬНЫЕ КАБИНЕТЫ
      // Берем uuid пользователя магазина
      setUserAsReceiverUuid(userUuid);
    })();
  }, [userUuid, employeeId, loadingUser, existStudentsAsReceivers]); // eslint-disable-line react-hooks/exhaustive-deps

  return [
    ...(studentsAsReceivers || []),
    ...(userAsReceiverUuid ? [{
      name,
      email,
      phone,
      user_uuid: userAsReceiverUuid,
    }] : []),
  ];
}
